import React from "react";

/**
 * Function to render a select down icon.
 *
 * @param {object} cls - The class name for the icon
 * @return {JSX.Element} The SVG icon component
 */
export const SelectDownIcon = ({ cls }) => {
  return (
    <svg
      width="13"
      height="7"
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M6.52966 6.99999C6.40697 7.00065 6.28535 6.97859 6.17176 6.93507C6.05818 6.89155 5.95487 6.82742 5.86775 6.74637L0.274171 1.49906C0.0986223 1.33438 0 1.11102 0 0.878129C0 0.645235 0.0986223 0.421879 0.274171 0.257198C0.44972 0.092517 0.687815 0 0.936079 0C1.18434 0 1.42244 0.092517 1.59799 0.257198L6.52966 4.89232L11.4613 0.265944C11.6397 0.122669 11.8691 0.0478021 12.1037 0.0563037C12.3383 0.0648054 12.5609 0.15605 12.7269 0.311803C12.893 0.467555 12.9902 0.676345 12.9993 0.896448C13.0084 1.11655 12.9286 1.33176 12.7758 1.49906L7.18225 6.74637C7.0086 6.90793 6.77423 6.99902 6.52966 6.99999Z"
        fill="currentColor"
      />
    </svg>
  );
};
